import { render, staticRenderFns } from "./PortfolioRow.vue?vue&type=template&id=2169bb55&"
import script from "./PortfolioRow.vue?vue&type=script&lang=js&"
export * from "./PortfolioRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports